import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';

export const CustomContentOnPageComponentLoader: LoadableType<{
	contentId: any;
	spaceKey: any;
	type: any;
}> = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-srcCustomContentOnPageComponent" */ '../src/CustomContentOnPageComponent.tsx'
			)
		).CustomContentOnPageComponent,
});
